import React from 'react';
import { fmtCompact } from '../format';
import { niceScale } from './chartUtils';

const WIDTH = 460;
const MARGIN = { left: 64, right: 12, top: 12, bottom: 28 };

// series: [{ name, color, values }] where a null value means "no data" and draws no bar
const BarChart = ({ categories, series, formatValue = fmtCompact, height = 260 }) => {
    const plotWidth = WIDTH - MARGIN.left - MARGIN.right;
    const plotHeight = height - MARGIN.top - MARGIN.bottom;

    const maxValue = Math.max(0, ...series.flatMap((s) => s.values.filter((v) => v !== null)));
    const scale = niceScale(maxValue);
    const y = (value) => MARGIN.top + plotHeight * (1 - value / scale.max);

    const groupWidth = plotWidth / categories.length;
    const barArea = groupWidth * 0.8;
    const barWidth = barArea / series.length;
    const groupOffset = (groupWidth - barArea) / 2;

    return (
        <div>
            {series.length > 1 && (
                <div style={{ fontSize: '0.8rem', color: '#666', marginBottom: '0.25rem' }}>
                    {series.map((s) => (
                        <span key={s.name} style={{ marginRight: '1rem' }}>
                            <span style={{ color: s.color }}>&#9632;</span> {s.name}
                        </span>
                    ))}
                </div>
            )}

            <svg viewBox={`0 0 ${WIDTH} ${height}`} style={{ width: '100%', height: 'auto' }} role="img">
                {scale.ticks.map((tick) => (
                    <g key={tick}>
                        <line x1={MARGIN.left} x2={WIDTH - MARGIN.right} y1={y(tick)} y2={y(tick)} stroke="#eceef1" />
                        <text x={MARGIN.left - 8} y={y(tick) + 4} textAnchor="end" fontSize="11" fill="#777">{formatValue(tick)}</text>
                    </g>
                ))}

                {categories.map((category, c) => (
                    <g key={category}>
                        {series.map((s, si) => {
                            const value = s.values[c];
                            if (value === null || value === undefined) return null;
                            const top = y(Math.max(value, 0));
                            return (
                                <rect
                                    key={s.name}
                                    x={MARGIN.left + c * groupWidth + groupOffset + si * barWidth}
                                    y={top}
                                    width={Math.max(barWidth - 1, 1)}
                                    height={y(0) - top}
                                    fill={s.color}
                                    rx="2"
                                >
                                    <title>{`${category} - ${s.name}: ${formatValue(value)}`}</title>
                                </rect>
                            );
                        })}
                        <text x={MARGIN.left + c * groupWidth + groupWidth / 2} y={height - 8} textAnchor="middle" fontSize="11" fill="#777">
                            {category}
                        </text>
                    </g>
                ))}
            </svg>
        </div>
    );
};

export default BarChart;
